import { levelFromJson, type Level } from '../models/level';
import { levelAssetPath } from '../models/world';

const cache = new Map<string, Level>();

export async function loadLevel(worldIndex: number, levelIndex: number): Promise<Level> {
  const path = levelAssetPath(worldIndex, levelIndex);
  const cached = cache.get(path);
  if (cached) return cached;

  const response = await fetch(`${import.meta.env.BASE_URL}${path}`);
  if (!response.ok) {
    throw new Error(`Could not load ${path} (HTTP ${response.status})`);
  }
  const level = levelFromJson(await response.json());
  cache.set(path, level);
  return level;
}
